
import { Box, Divider } from '@mui/material';
import { experimentalStyled } from '@mui/material/styles';
//import LogoBase from 'main/components/Logo/logobase';
import PartnerContext from "main/contexts/PartnerContext";
import {useContext} from "react";
//import linkalianzaLogo from "main/assets/linkalianza_logo.svg"
import avistaLogo from "main/assets/logos/logo_avistapp.svg"
import linkalianzaLogo from "main/assets/logos/logo_linkalianza.svg"
// import HeaderMenu from './Menu';
// import HeaderUserbox from './Userbox';
import { keyframes } from '@emotion/react';
import { useLocation } from 'react-router-dom';

const HeaderWrapper = experimentalStyled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 5;
        background-color: ${theme.header.background};
        box-shadow: ${theme.header.boxShadow};
        position: fixed;
        justify-content: space-between;
        width: 100%;
`
);

function Header() {
    const { partner } = useContext(PartnerContext);
    const location = useLocation();
    const steps = ['Visualización de documentos', 'Persona reconocida', 'Firma aceptada'];
    const activeColor = partner.name === "avista" ? '#c23d73' : '#ff4d00';
    const inactiveColor = '#c9c9c9';
    const pulse = keyframes`
      0% { transform: scale(1); }
      50% { transform: scale(1.4); }
      100% { transform: scale(1); }
    `;

    // La confirmación de validación de identidad no muestra el paso a paso
    const showSteps = location.pathname !== '/identity-validation/confirmation';

    let activeStep = 0;
    if (location.pathname.includes('success')) {
      activeStep = 2;
    } else if (location.pathname.includes('verification-identity') || location.pathname.includes('verify') || location.pathname.includes('verify-otp')) {
      activeStep = 1;
    } else {
      activeStep = 0;
    }

  return (
    <HeaderWrapper display="flex" alignItems="center">
      <Box display="flex" alignItems="center" justifyContent={'center'} width={1}>
        {partner.name === "linkAlianza" &&
          <Box display="flex" flexDirection="column" alignItems="center" width={1}>
            <Box>
              <img width={130} src={linkalianzaLogo}/>
            </Box>
            {showSteps && <>
            <Divider sx={{ width: 1, my: 1.5 }} />
            <Box display="flex" alignItems="center" justifyContent="flex-start" width={1} px={2} py={0.5}>
              <Box display="flex" alignItems="center" mr={1}>
                {[0,1,2].map((i) => (
                  <Box
                    key={i}
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: i <= activeStep ? activeColor : inactiveColor,
                      marginRight: i < 2 ? '6px' : 0,
                      animation: i === activeStep ? `${pulse} 1.5s infinite ease-in-out` : 'none'
                    }}
                  />
                ))}
              </Box>
              <Box fontWeight="bold" color="#6c6c6e">{steps[activeStep]}</Box>
            </Box>
            </>}
          </Box>
        }
        {partner.name === "avista" &&
          <Box display="flex" flexDirection="column" alignItems="center" width={1}>
            <Box >
              <img width={150} src={avistaLogo}/>
            </Box>
            {showSteps && <>
            <Divider sx={{ width: 1, my: 1.5 }} />
            <Box display="flex" alignItems="center" justifyContent="flex-start" width={1} px={2} py={0.5}>
              <Box display="flex" alignItems="center" mr={1}>
                {[0,1,2].map((i) => (
                  <Box
                    key={i}
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: i <= activeStep ? activeColor : inactiveColor,
                      marginRight: i < 2 ? '6px' : 0,
                      animation: i === activeStep ? `${pulse} 1.5s infinite ease-in-out` : 'none'
                    }}
                  />
                ))}
              </Box>
              <Box fontWeight="bold" color="#6c6c6e">{steps[activeStep]}</Box>
            </Box>
            </>}
          </Box>
        }
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
